<template>
  <v-container>
    <div v-show="!isReady" class="loading-block"> 
      <div class="loader"></div>
    </div>
    <div class="d-flex flex-row mb-2">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn class="ma-1" v-on="on" to="/">
            <v-icon color="black">mdi-chevron-left</v-icon>
            <span class="ml-1 hidden-sm-and-down">Back to archive</span>
          </v-btn>                     
        </template>
        <span>Go back to cd's archive</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip top v-if="cd.zip.url">
        <template v-slot:activator="{ on }">
          <v-btn class="ma-1" v-on="on" :href="cd.zip.url" :download="cd.zip.name" @click="trackDownload(cd.year+' '+cd.title+' - ZIP')">
            <v-icon color="black">mdi-download</v-icon>
            <span class="ml-1 hidden-sm-and-down">Download Entire CD</span>
          </v-btn>                     
        </template>
        <span>Download all tracks</span>
      </v-tooltip>
      <v-tooltip top v-if="cd.transcript.url">
        <template v-slot:activator="{ on }">
          <v-btn v-if="!isMobile()"  class="ma-1" v-on="on" :href="cd.transcript.url" @click.prevent="directDownload(cd.transcript.url, cd.transcript.name, cd.year+' '+cd.title+' - PDF')">
            <v-icon color="red">mdi-pdf-box</v-icon>
            <span class="ml-1 hidden-sm-and-down">Transcript</span>
          </v-btn>
          <v-btn v-else class="ma-1" v-on="on" :href="cd.transcript.url" :download="cd.transcript.name" @click="trackDownload(cd.year+' '+cd.title+' - PDF')">
            <v-icon color="red">mdi-pdf-box</v-icon>
            <span class="ml-1 hidden-sm-and-down">Transcript</span>
          </v-btn>
        </template>
        <span>Read/Download Transcript</span>
      </v-tooltip>
      <!--
      <v-tooltip top v-if="cd.buy_url">
        <template v-slot:activator="{ on }">
          <v-btn class="ma-1" v-on="on" :href="cd.buy_url" target="_blank">
            <v-icon color="green">mdi-cart</v-icon>
            <span class="ml-1 hidden-sm-and-down">Buy CD</span>
          </v-btn>                     
        </template>
        <span>Buy this Cd on MedioMedia</span>
      </v-tooltip>
      -->
    </div>
    <v-card elevation="4" class="mb-10">
      <div class="posRel audioPlayerWrapper">
        <div class="posAbs audioPlayerBg" :style="{ backgroundImage: `linear-gradient(to right top, rgba(100, 115, 201, 0.33), rgba(42, 59, 77, 0.6)), url('${cd.artwork.url}')`}"></div>
        <v-row no-gutters class="posRel">
          <v-col cols="12" md="8" class="pa-3">
            <v-layout column fill-height class="lightbox white--text" style="min-height:260px">
              <div class="info-cd">
                <p class="mb-0"><span class="d-inline-block px-3 py-1 grey darken-4 white--text caption">Meditatio Talks Series <strong>{{ cd.year }}</strong> - Release date <strong>{{ cd.release_date | moment("D MMMM YYYY") }}</strong></span></p>
                <h3><span class="d-inline-block my-1 px-3 py-1 grey darken-4 white--text">{{cd.title}} <span class="caption">by {{cd.teacher}}</span></span></h3>
                <p class="mb-0 subheading"><span class="d-inline-block px-3 py-1 grey darken-4 white--text">{{ currentTrackNumber }} <strong>{{ currentTrackTitle }}</strong></span></p>
              </div>
                <v-spacer></v-spacer>
                <v-flex shrink>
                  <div class="text-center playerButtons mt-3 mb-1">
                    <v-btn
                      :disabled="currentTrack==0"
                      fab
                      small
                      @click.stop="prevSong"
                      dark
                    >
                      <v-icon>mdi-skip-previous</v-icon>
                    </v-btn>
                    <v-btn
                      fab
                      large
                      @click.stop="playAudio"
                      class="mx-1"
                      dark
                    >
                      <v-icon x-large>{{ currentlyPlaying ? 'mdi-pause' : 'mdi-play' }}</v-icon>
                    </v-btn>
                    <v-btn
                      :disabled="currentTrack == tracks.length-1"
                      fab   
                      small            
                      @click.stop="nextSong"
                      dark
                    >
                      <v-icon>mdi-skip-next</v-icon>
                    </v-btn>
                  </div>
                  <div class="audioPlayerUI">
                    <div class="currentTimeContainer" style="text-align:center">
                      <span class="currentTime">{{ currentTime | fancyTimeFormat }}</span>
                      <span class="totalTime"> {{ currentTrackDuration | fancyTimeFormat }}</span>
                    </div>
                    <div class="currentProgressBar">
                      <div class="currentBar currentLoad" :style="{ width: currentLoadBar + '%' }"></div>
                      <div class="currentBar currentProgress" :style="{ width: currentProgressBar + '%' }"></div>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
          </v-col>
          <v-col cols="12" md="4" class="pa-3">
            <v-card>
              <v-img 
              :src="cd.artwork.url"
              width="100%"
              >
              </v-img>
            </v-card>
          </v-col>          
        </v-row>
      </div> 
      <v-row no-gutters>
        <v-col cols="12" md="8" class="pa-4">
          <div v-html="cd.description" class="mb-12 px-5 pt-3"></div>
          <v-alert
            color="#2A3B4D"
            dark
            icon="mdi-information"
            dense
          >
            <p>The tracks on this playlist are intended solely for personal non-commercial use. By downloading tracks from this playlist you agree to use the downloaded files only for personal, non-commercial use.</p>
            <p>This resource is provided free. If you would like to support our mission to communicate and nurture meditation in the Christian tradition as passed on through the teaching of John Main OSB, please <a class="white--text" href="https://tiny.cc/donateWCCM" target="_blank">contribute here</a>.</p>
          </v-alert>
        </v-col>             
        <v-col cols="12" md="4" class="py-3 px-2">
          <v-list dense class="pa-0">
            <v-list-item-group>
              <v-list-item 
                v-for="(track, index) in tracks"
                :key="index"
                :class="{ 'v-list-item--isActive' : isCurrentSong(index) }"
              >
                <v-list-item-content v-if="isCurrentSong(index) && currentlyPlaying">
                  <v-list-item-title>{{ ('0' + (index + 1) ).slice(-2) }} <strong>{{ track.title }}</strong></v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else @click.stop="setTrack(index, 'go')">
                  <v-list-item-title>{{ ('0' + (index + 1) ).slice(-2) }} <strong>{{ track.title }}</strong></v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>           
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-if="!isMobile()" color="black" small icon v-on="on" :href="track.url" @click.prevent="directDownload(track.url, track.fileName, cd.year+' '+cd.title+' - TRACK '+('0' + (index + 1) ).slice(-2))">
                        <v-icon>mdi-download</v-icon>
                      </v-btn>                     
                    </template>
                    <span>Download track {{ ('0' + (index + 1) ).slice(-2) }}</span>
                  </v-tooltip>     
                </v-list-item-action>          
              </v-list-item>
            </v-list-item-group>
          </v-list>          
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios'
import { analytics } from '@/firebase/'
import { db } from '@/firebase/'

export default {
  name: 'cd',
  data () {
    return {
      isReady: false,
      cd: {
        _storage_folder: '',
        published: false,
        title: '',
        artwork: {},
        transcript: {},
        zip: {},
        year: '',
        release_date: '',
        teacher: '',
        description: '',
        buy_url: '',
        soundcloud_url: '',
        tracks: []
      },
      tracks: [],
      currentTrack: 0,  
      currentTrackNumber: '',
      currentTrackTitle: '',
      currentTime: 0,
      currentTrackDuration: 0,
      currentProgressBar: 0, 
      currentLoadBar: 0,  
      checkingCurrentPositionInTrack: '',   
      currentlyPlaying: false,
      currentlyStopped: false,
      audio: {}
    }
  },
  metaInfo() {
    return { 
      title: this.cd.year + ' - ' + this.cd.title,
      titleTemplate: '%s | Meditatio Talks Series'
    }
  },
  mounted() {
    this.getCdData();
  },
	filters: {
		fancyTimeFormat: function(s) {
			return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
		}		
	},  
	methods: {
    async getCdData () {
      let cdData = await db.collection('meditatiotalks').doc(this.$route.params.id).get().then(function(doc) {
        return doc.data()
      })      
      //set data 
      this.cd = cdData
      this.tracks = cdData.tracks
      //set initial track
      this.setTrack(this.currentTrack)
      // set isReady to visible the page
      this.isReady = true
    },
		nextSong: function() {
			if (this.currentTrack < this.tracks.length - 1) this.setTrack(this.currentTrack + 1);
		},
		prevSong: function() {
      if (this.currentTrack > 0) this.setTrack(this.currentTrack - 1);
		},          
    setTrack: function(i, b) {
      var wasPlaying = this.currentlyPlaying;
      this.stopAudio();
      this.currentTrack = i
      this.currentTime = 0
      this.currentProgressBar = 0
      this.currentLoadBar = 0
      this.currentTrackNumber = ('0' + (i + 1) ).slice(-2)
      this.currentTrackTitle = this.tracks[i].title
      this.audio = new Audio(this.tracks[i].url)
      var localThis = this
			this.audio.addEventListener("loadedmetadata", function() {
				localThis.currentTrackDuration = Math.round(this.duration)
      })
      this.audio.addEventListener("ended", this.handleEnded);
      if (wasPlaying || b) {
        this.playAudio();
			}
    },  
    isCurrentSong: function(i) {
			if (this.currentTrack == i) {
				return true;
			}
			return false;
    },
		playAudio: function() {
			if (
				this.currentlyStopped == true &&
				this.currentTrack + 1 == this.tracks.length
			) {
				this.currentTrack = 0;
				this.changeSong();
			}
			if (!this.currentlyPlaying) {
				this.getCurrentTimeEverySecond(true);
				this.currentlyPlaying = true;
        this.audio.play(this.tracks.name);
			} else {
				this.stopAudio();
			}
      this.currentlyStopped = false;
      this.trackListen(this.cd.year+' '+this.cd.title+' - TRACK '+this.currentTrackNumber);
		},
		stopAudio: function() {
      if(this.currentlyPlaying){
        this.audio.pause();
        this.currentlyPlaying = false;
        this.pausedMusic();
      }
		},
		handleEnded: function() {
			if (this.currentTrack + 1 == this.tracks.length) {
				this.stopAudio();
				this.currentlyPlaying = false;
				this.currentlyStopped = true;
			} else {
				this.currentlyPlaying = false;
				this.currentTrack++;
				this.setTrack(this.currentTrack);
				this.playAudio();
			}
		},   
		getCurrentTimeEverySecond: function() {
			var localThis = this;
			this.checkingCurrentPositionInTrack = setTimeout(
				function() {
					localThis.currentTime = localThis.audio.currentTime;
          localThis.currentProgressBar = localThis.audio.currentTime / localThis.currentTrackDuration * 100;
          localThis.currentLoadBar = localThis.audio.buffered.end(0) / localThis.currentTrackDuration * 100;
					localThis.getCurrentTimeEverySecond(true);
				}.bind(this),
				1000
      );
    },
    pausedMusic: function() {
			clearTimeout(this.checkingCurrentPositionInTrack);
    },
    onkeydown: function(e) {
      if (this.audio) {
        if (e.keyCode === 37) {
          this.prevSong()
          e.preventDefault()
        }
        if (e.keyCode === 39) {
          this.nextSong()
          e.preventDefault()
        }
        if (e.keyCode === 32) {
          this.playAudio()
          e.preventDefault()
        }
      }
    },
    directDownload(url, label, label_stats) {
      axios.get(url, { responseType: 'blob' })
      .then(response => {
        this.trackDownload(label_stats)
        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = label
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(() => window.console.log('error occured'))
    },
    trackDownload(name){
      analytics.logEvent("file_download", {
        file_name: name
      });      
    },
    trackListen(name){
      analytics.logEvent("meditatiotalks_listen", {
        track_info: name
      });      
    },   
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }       	
  },
	watch: {
		currentTime: function() {
			this.currentTime = Math.round(this.currentTime);
		}    
	},
	beforeDestroy: function() {
    this.stopAudio()
		this.audio.removeEventListener("ended", this.handleEnded);
		this.audio.removeEventListener("loadedmetadata", this.handleEnded);  
    this.audio = ''
  },
  created() {
    document.onkeydown = this.onkeydown
  }  
};
</script>


<style lang="scss">
.posRel {position: relative;}
.posAbs {position: absolute;}

.loading-block {
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  .loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #ab4538;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.audioPlayerWrapper {
  .info-cd {
    line-height: 1.7em;
  }
}
.audioPlayerBg {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  background-size: cover;
  background-position: bottom right;
  position: absolute;
  opacity: .7;
  height: 100%;
  width: 100%;
}
.audioPlayerUI {
  .currentTimeContainer {
    user-select: none;
    width: 100%;
    height: 1rem; 
    display: flex;
    justify-content: space-between;
    .currentTime,
    .totalTime {
      font-size: 1rem;
      font-weight: 800;
      color: #000;
      text-shadow: 1px 1px #fff;
    }
  }
  .currentProgressBar {
    width: 100%;
    background-color: rgba(0, 0, 0, .2);
    margin:0.75rem 0;
    position: relative;
    height: 5px;
    .currentBar {
      position: absolute;
      top: 0;
      left: 0;
      width: 0px;
      height: 100%;
      transition: 100ms;
    }
    .currentLoad {
      z-index: 1;      
      background-color: #000;
    }
    .currentProgress {
      z-index: 2;
      background-color: #fff;
    }
    
  }
}

.theme--light.v-list-item--active::before {
    opacity: 0;
}
.theme--light.v-list-item--isActive::before {
    opacity: 0.3;
    color: #2A3B4D;
}
</style>